import React, { useEffect, useState, useContext } from 'react';
import { Layout, Input, Avatar, List, Typography, Button, Popover, Modal, Spin, Form, Select, Slider, Collapse,Tag } from 'antd';
import { UserOutlined, SendOutlined, RobotOutlined, ReloadOutlined, GoogleOutlined, LogoutOutlined,FileTextOutlined } from '@ant-design/icons';
import axios from 'axios';
import '../App.css';
import { AuthContext } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

const { Header, Content, Footer, Sider } = Layout;
const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
const { Text } = Typography;

const Chat = () => {
  const LLMs = {
    openAI: [
      { label: 'gpt-3.5-turbo', value: 'gpt-3.5-turbo' },
      { label: 'gpt-4-1106-preview', value: 'gpt-4-1106-preview' },
      { label: 'gpt-4-0125-preview', value: 'gpt-4-0125-preview' }
    ],
    cohere: [
      { label: 'command', value: 'command' },
      { label: 'command-light', value: 'command-light' },
      { label: 'command-light-nightly', value: 'command-light-nightly' },
      { label: 'command-r', value: 'command-r' },
      { label: 'command-r-plus', value: 'command-r-plus' },
    ],
    claude: [
      { label: 'claude-3-sonnet', value: "anthropic.claude-3-sonnet-20240229-v1:0" },
      { label: 'claude-3-5-sonnet', value: "anthropic.claude-3-5-sonnet-20240620-v1:0" },
      { label: 'claude-3-haiku', value: "anthropic.claude-3-haiku-20240307-v1:0" },
    ],
    mistral: [
      { label: 'mistral-7b-instruct', value: "mistral.mistral-7b-instruct-v0:2" },
      { label: "mistral-8x7b-instruct", value: "mistral.mixtral-8x7b-instruct-v0:1" },
      { label: "mistral-large", value: "mistral.mistral-large-2402-v1:0" },
    ],
    lama: [
      { label: 'llama3-8b-instruct', value: "meta.llama3-8b-instruct-v1:0" },
      { label: "llama3-70b-instruct", value: "meta.llama3-70b-instruct-v1:0" }
    ]
  };



  const { setAuthToken, userDetails } = useContext(AuthContext);
  const navigate = useNavigate();
  const [selectedProvider, setSelectedProvider] = useState('openAI');
  const [agentName, setagentName] = useState('');
  const [agentSelection, setAgentSelection] = useState({ status: false });
  const [selectedVersion, setSelectedVersion] = useState(LLMs.openAI[0].value);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAgentModalVisible, setIsAgentModalVisible] = useState(false);
  const [displayChat, setDisplayChat] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [lastUserMessage, setLastUserMessage] = useState(null);
  const [randomness, setRandomness] = useState(0.5)
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isModelDropdownVisible, setIsModelDropdownVisible] = useState(false);
  const [agentDetails, setAgentDetails] = useState(null);
  const [systemPrompt, setSystemPrompt] = useState("")
  const [testcaseStatus, setTestcaseStatus] = useState("")
  
  const [form] = Form.useForm();
  const [fewShotPrompts, setFewShotPrompts] = useState([{ id: 1, userInput: '', modelOutput: '' }]);
  const [isTestCaseModalVisible, setIsTestCaseModalVisible] = useState(false);
  const [testCaseForm] = Form.useForm();
  const [displayTestCases, setDisplayTestCases] = useState([]);
  const [testCaseInput, setTestCaseInput] = useState('');
  const [testCaseOutput, setTestCaseOutput] = useState('');
  const [testCaseAgentId, setTestCaseAgentId] = useState('');
  const [testcaseModelVisible, setTestcaseModelVisible] = useState('');
  const [testcaseName, setTestCaseName] = useState('');
  const [testcaseReport, setTestcaseReport] = useState(false);
  const [testCaseExecuteModel, setTestCaseExecuteModel] = useState(selectedVersion);
  const [testCaseExecuteProvider, setTestCaseExecuteProvider] = useState(selectedProvider);


  const handleOk = () => {
    // Handle form submission or any actions needed
    setIsModalVisible(false);
  };
  useEffect(() => {
    handleAgentAction()
    fetchTestCases()
  }, [])


  const fetchTestCases = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/testcase/${userDetails.email}`);
      console.log(response.data)
      setDisplayTestCases(response.data);
    } catch (error) {
      console.error("Error fetching test cases:", error);
    }
  };

  const runtestcase=async()=>
  {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/testcase/${userDetails.email}`);
      setTestcaseStatus(response.data)
      setTestcaseReport(true)
      setTestcaseReport(true)
      console.log(response.data)
    } catch (error) {
      console.error("Error fetching test cases:", error);
    }
  }

  const handleTestCaseSubmit = async () => {
    const payload = {
      name:testcaseName,
      userId: userDetails.id,
      input: testCaseInput,
      output: testCaseOutput,
      agentId: JSON.parse(testCaseAgentId),
      executeModel: testCaseExecuteModel,
      executeProvider: testCaseExecuteProvider,
    };
    console.log(payload);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/testcase`, payload);
      console.log('Test case created successfully:', response.data);
      setDisplayTestCases([...displayTestCases, response.data]);  // Update test case list
      setIsTestCaseModalVisible(false);  // Close the modal after successful creation
      testCaseForm.resetFields();  // Reset form fields
    } catch (error) {
      console.error('Error creating test case:', error);
    }
  };

  const handleFormSubmit = async () => {
    let payload = {
      name:agentName,
      provider: selectedProvider,
      modal: selectedVersion,
      randomness: randomness,
      systemPrompt: systemPrompt,
      userId: userDetails.id,
    };
    if(fewShotPrompts[0].userInput.trim()!="" &&  fewShotPrompts[0].modelOutput.trim()!="")
    {
      payload={...payload,fewShotPrompts:fewShotPrompts}
    }
    console.log(payload);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/agent`, payload);
      console.log('Agent created successfully:', response.data);
      setAgentDetails([...agentDetails,response.data]); 
     console.log([ ...agentDetails,response.data]) // Update agent details with the new agent
      setIsAgentModalVisible(false);  // Close the modal after successful creation
    } catch (error) {
      console.error('Error creating agent:', error);
      // Handle error (e.g., show an error message)
    }
  };


  const handleModalModelSelect = (provider, version) => {
    setSelectedProvider(provider);
    setSelectedVersion(version);
    setIsModelDropdownVisible(false);  // Hide the dropdown after selection
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const addFewShotPrompt = () => {
    setFewShotPrompts([...fewShotPrompts, { id: fewShotPrompts.length + 1, userInput: '', modelOutput: '' }]);
  };

  const handleFewShotChange = (index, field, value) => {
    const newPrompts = [...fewShotPrompts];
    newPrompts[index][field] = value;
    setFewShotPrompts(newPrompts);
  };

  const handleAgentAction = async () => {
    console.log(userDetails)

    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/agent/by-email?email=${userDetails.email}`); // Adjust the URL based on your API endpoint
     
      setAgentDetails(response.data);
      console.log(response.data)
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setAgentDetails(null); // No agent found

      } else {
        console.error("Error fetching agent details:", error);
      }
    }
  }

  const modalVisible = () => {
    setIsModalVisible(true);
  }

  const handleLogout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/api/auth/logout`);
    } catch (error) {
      console.error("Logout error:", error);
    }
    setAuthToken(null);
    navigate('/login');
  };

  

  const content = (
    <div>
      <p style={{ cursor: 'pointer' }} onClick={modalVisible}>
        View Agent
      </p>
      <p style={{ cursor: 'pointer' }} onClick={()=>setIsAgentModalVisible(true)}>
        Create Agent
      </p>
      <p style={{ cursor: 'pointer' }} onClick={()=>setTestcaseModelVisible(true)}>
        View TestCase
      </p>
      <p style={{ cursor: 'pointer' }} onClick={()=>setIsTestCaseModalVisible(true)}>
        Create TestCase
      </p>
      <p style={{ cursor: 'pointer' }} onClick={handleLogout}>
        Logout <LogoutOutlined style={{ color: 'red' }} />
      </p>
    </div>
  );


  const handleModelSelect = (provider, version) => {
    setSelectedProvider(provider);
    setSelectedVersion(version);
    setAgentSelection({status: false,id:"" })
    setIsDropdownVisible(false);  // Hide the dropdown after selection
  };

  const handleTestCaseModelSelect = (provider, version) => {
    setTestCaseExecuteProvider(provider);
    setTestCaseExecuteModel(version);
    setIsModelDropdownVisible(false); // Optionally close the dropdown after selection
  };

  const handleSend = async (messageToSend = inputValue) => {
    if (messageToSend.trim() !== "") {
      const userMessage = { role: 'user', request: messageToSend };
      setDisplayChat([...displayChat, userMessage]);
      setInputValue("");
      setLoading(true);
      setLastUserMessage(messageToSend);

      try {
        if (agentSelection.status) {
          const response = await axios.post(`${process.env.REACT_APP_API}/agent/${agentSelection.id}`, {
            role:"user",
            content: messageToSend,
          });
          console.log(response.data)
          const systemMessage = { role: 'system', request: response.data.content };
          setDisplayChat(prevChat => [...prevChat, systemMessage]);
          setLoading(false);

        }
        else {
          const response = await axios.post(`${process.env.REACT_APP_API}/${selectedProvider}/${selectedVersion}/process`, {
            prompt: messageToSend,
          });
          console.log(response.data)
          const systemMessage = { role: 'system', request: response.data.content };
          setDisplayChat(prevChat => [...prevChat, systemMessage]);
          setLoading(false);

        }



      } catch (error) {
        console.error("Error while sending message:", error);
        const errorMessage = { role: 'system', request: 'Error: Unable to reach the server.' };
        setDisplayChat(prevChat => [...prevChat, errorMessage]);
        setLoading(false);
      }
    }
  };
  const handleAgentSelect = (id, provider, version) => {
    setAgentSelection({ status: true, id: id });
    setSelectedProvider(provider);
    setSelectedVersion("");
    setIsDropdownVisible(false);  // Hide the dropdown after selection
  };
  

  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#1a1a1a' }}>
      <Sider width={300} style={{ backgroundColor: '#1a1a1a', padding: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ color: '#FFFFFF', fontSize: '24px', fontWeight: 'bold' }}>ZFusion</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", height: "95%", justifyContent: "space-between" }}>
          <Input.Search
            placeholder="Search..."
            style={{ marginBottom: '20px', backgroundColor: '#333333', borderColor: '#8C2BE4' }}
            allowClear
          />

          <Popover content={content} title="Settings" trigger="click" style={{ padding: '0 20px', color: '#FFFFFF' }}>
            <span style={{ display: 'flex', alignItems: 'center', cursor: "pointer", gap: "7px" }}>
              <div style={{ color: "white" }}>Sathishbabu Shanmugam</div>
              <div>
                <Button shape="circle" icon={<UserOutlined />} style={{ backgroundColor: '#8C2BE4', borderColor: '#8C2BE4' }} />
              </div>
            </span>
          </Popover>
        </div>
      </Sider>
      <Layout style={{ backgroundColor: "#1a1a1a" }}>
        <Header style={{ color: 'white', padding: '10px', textAlign: 'right' }}>
          <Text style={{ color: "white" }} strong>{selectedProvider.toUpperCase()} ({selectedVersion})</Text>
        </Header>
        <Content style={{ padding: '20px', backgroundColor: '#1a1a1a', maxHeight: 'calc(100vh - 160px)', overflowY: 'auto' }}>
          {loading && <div style={{ textAlign: 'center', margin: '20px' }}><Spin size="large" /></div>}
          <List
            itemLayout="horizontal"
            dataSource={displayChat}
            renderItem={item => (
              <List.Item>
                <List.Item.Meta
                  style={{ color: "white" }}
                  avatar={<Avatar icon={item.role === 'user' ? <UserOutlined /> : <RobotOutlined />} />}
                  title={item.role === 'user' ? "You" : "Zauto Agent"}
                  description={item.request}
                />
              </List.Item>
            )}
          />
        </Content>

        <Footer style={{ backgroundColor: '#1a1a1a', gap: "20px", padding: '10px 20px', display: 'flex', alignItems: 'center', width: "100%", margin: "auto", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              onClick={() => setIsDropdownVisible(!isDropdownVisible)}
              style={{ width: "fit-content", padding: '8px', backgroundColor: '#333333', borderRadius: '5px', color: 'white', cursor: 'pointer' }}
            >
              {selectedProvider.toUpperCase()}/{selectedVersion.toUpperCase()}
            </div>
            {isDropdownVisible && (
              <div style={{ position: "absolute", height: "300px", overflow: "auto", bottom: '100px', width: 'calc(100% - 20%)', backgroundColor: '#333333', borderRadius: '5px', zIndex: 100, right: "0" }}>
                {Object.entries(LLMs).map(([provider, models]) => (
                  <div key={provider}>
                    <div style={{ padding: '10px', fontWeight: 'bold', color: '#8C2BE4' }}>
                      {provider.toUpperCase()} MODELS
                    </div>
                    {models.map(model => (
                      <div
                        key={model.value}
                        onClick={() => handleModelSelect(provider, model.value)}
                        style={{
                          padding: '10px 20px',
                          cursor: 'pointer',
                          color: 'white',
                          backgroundColor: model.value === selectedVersion && !agentSelection.status ? '#8C2BE4' : 'transparent',
                        }}
                      >
                        {model.label}
                      </div>
                    ))}

                  </div>
                ))}
              {agentDetails && (
  <div>
    <div style={{ padding: '10px', fontWeight: 'bold', color: '#8C2BE4' }}>
      Custom Agent
    </div>
    {agentDetails.map(agent => (
      <div
        key={agent.modal}
        onClick={() => handleAgentSelect(agent.id, agent.name, agent.modal)}
        style={{
          padding: '10px 20px',
          cursor: 'pointer',
          color: 'white',
          backgroundColor: agentSelection.status && agent.id === agentSelection.id ? '#8C2BE4' : 'transparent',
        }}
      >
        {agent.name}
      </div>
    ))}
  </div>
)}

                <div>
                  <div style={{ padding: '10px', fontWeight: 'bold', color: '#8C2BE4' }}>
                    Agent Creation
                  </div>

                  <div
                    key="New Agent"
                    onClick={() => setIsAgentModalVisible(true)}
                    style={{
                      padding: '10px 20px',
                      cursor: 'pointer',
                      color: 'white',
                      backgroundColor: 'transparent',
                    }}
                  >
                    Create New Agent
                  </div>
                </div>

              </div>
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexGrow: 1 }}>
            <TextArea
              rows={1}
              className="textarea-placeholder"
              style={{
                backgroundColor: '#333333',
                color: 'white',
                borderColor: '#8C2BE4',
                width: '100%'
              }}
              placeholder="Ask anything!"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onPressEnter={() => handleSend(inputValue)}
            />
            <Button
              shape="circle"
              icon={<SendOutlined />}
              style={{ backgroundColor: '#8C2BE4', borderColor: '#8C2BE4' }}
              onClick={() => handleSend(inputValue)}
            />
            {lastUserMessage && (
              <Button
                shape="circle"
                icon={<ReloadOutlined />}
                style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
                onClick={() => handleSend(lastUserMessage)}
              />
            )}
          </div>
        </Footer>
      </Layout>
      <Modal
        title="Model"
        visible={isAgentModalVisible}
        onCancel={() => setIsAgentModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={()=>setIsAgentModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => {
            handleFormSubmit();

          }}>
            Submit
          </Button>,
        ]}
      >


        <Form layout="vertical" form={form} onFinish={handleFormSubmit}>
          {/* Model Selection */}
          <Form.Item label="Agent Name">
            <Input value={agentName} onChange={(e)=>setagentName(e.target.value)}/>
          </Form.Item>

          <Form.Item label="Model">
            <div
              onClick={() => setIsModelDropdownVisible(!isModelDropdownVisible)}
              style={{ width: "100%", padding: '8px', borderRadius: '5px', color: 'black', cursor: 'pointer', border: "2px dotted #8C2BE4" }}
            >
              {selectedProvider.toUpperCase()}/{selectedVersion.toUpperCase()}
            </div>
            {isModelDropdownVisible && (
              <div style={{ position: "absolute", maxHeight: "300px", overflow: "auto", width: '100%', backgroundColor: '#333333', borderRadius: '5px', zIndex: 100, marginTop: '8px' }}>
                {Object.entries(LLMs).map(([provider, models]) => (
                  <div key={provider}>
                    <div style={{ padding: '10px', fontWeight: 'bold', color: '#8C2BE4' }}>
                      {provider.toUpperCase()} MODELS
                    </div>
                    {models.map(model => (
                      <div
                        key={model.value}
                        onClick={() => handleModalModelSelect(provider, model.value)}
                        style={{
                          padding: '10px 20px',
                          cursor: 'pointer',
                          color: 'white',
                          backgroundColor: model.value === selectedVersion ? '#8C2BE4' : 'transparent',
                        }}
                      >
                        {model.label}
                      </div>
                    ))}

                  </div>
                ))}

              </div>
            )}
          </Form.Item>

          {/* Randomness */}
          <Form.Item label="Randomness">
            <Slider
              min={0}
              max={1}
              step={0.01}
              value={randomness}
              onChange={(value) => setRandomness(value)}
            />
            <Input
              value={randomness.toFixed(2)}
              readOnly
              style={{ width: '100px', marginTop: '10px' }}
            />
          </Form.Item>

          {/* System Prompt */}
          <Form.Item label="Enter a system prompt for the model (Optional)">
            <TextArea rows={2} name='systemPrompt' value={systemPrompt} onChange={(event) => setSystemPrompt(event.target.value)} placeholder="Enter system prompt" />
          </Form.Item>

          {/* Demonstrations Section */}
          <Form.Item label="Demonstrations">
            <Form.Item label="Few-Shot Prompts">
              {fewShotPrompts.map((prompt, index) => (
                <div key={prompt.id} style={{ marginBottom: '16px' }}>
                  <Input
                    placeholder={`User input ${index + 1}`}
                    value={prompt.userInput}
                    onChange={(e) => handleFewShotChange(index, 'userInput', e.target.value)}
                    style={{ marginBottom: '8px' }}
                  />
                  <TextArea
                    rows={2}
                    placeholder={`Model output ${index + 1}`}
                    value={prompt.modelOutput}
                    onChange={(e) => handleFewShotChange(index, 'modelOutput', e.target.value)}
                  />
                </div>
              ))}
              <Button type="dashed" onClick={addFewShotPrompt} block>
                Add Another Few-Shot Prompt
              </Button>
            </Form.Item>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Agents"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>
        ]}
      >
        {agentDetails?.map((agent, index) => <Collapse style={{ marginTop: "10px" }} key={index} >
          <Panel header={`Agent: ${agent?.name.toUpperCase()}`} key="1">
            <p><strong>Provider Name:</strong> {agent?.provider.toUpperCase()}</p>
            <p><strong>Model:</strong> {agent?.modal.toUpperCase()}</p>
            <p><strong>Randomness:</strong> {agent?.randomness}</p>
            <p><strong>System Prompt:</strong> {agent?.systemPrompt.toUpperCase()}</p>

            <Collapse>
              <Panel header="Few-Shot Prompts">
                <ul>
                  {agent?.fewShotPrompts?.map((prompt, index) => (
                    <li key={index}>
                      <p><strong>User Input {index + 1}:</strong> {prompt.userInput.toUpperCase()}</p>
                      <p><strong>Model Output {index + 1}:</strong> {prompt.modelOutput.toUpperCase()}</p>
                    </li>
                  ))}
                </ul>
              </Panel>
            </Collapse>
          </Panel>
        </Collapse>)}



      </Modal>


      <Modal
        title="Add Test Case"
        visible={isTestCaseModalVisible}
        onCancel={() => setIsTestCaseModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsTestCaseModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleTestCaseSubmit}>
            Submit
          </Button>,
        ]}
      >
        <Form layout="vertical" form={testCaseForm} onFinish={handleTestCaseSubmit}>
        <Form.Item label="Name">
          <Input value={testcaseName} onChange={(e)=>setTestCaseName(e.target.value)}  />
           </Form.Item>
          <Form.Item label="Input">
            <TextArea rows={2} value={testCaseInput} onChange={(e) => setTestCaseInput(e.target.value)} placeholder="Enter test case input" />
          </Form.Item>

          <Form.Item label="Expected Output">
            <TextArea rows={2} value={testCaseOutput} onChange={(e) => setTestCaseOutput(e.target.value)} placeholder="Enter expected output" />
          </Form.Item>

          <Form.Item label="Agent ID">
            <Input type='number' value={testCaseAgentId} onChange={(e) => setTestCaseAgentId(e.target.value)} />
          </Form.Item>

          <Form.Item label="Model">
            <div
              onClick={() => setIsModelDropdownVisible(!isModelDropdownVisible)}
              style={{ width: "100%", padding: '8px', borderRadius: '5px', color: 'black', cursor: 'pointer', border: "2px dotted #8C2BE4" }}
            >
              {testCaseExecuteProvider.toUpperCase()}/{testCaseExecuteModel.toUpperCase()}
            </div>
            {isModelDropdownVisible && (
              <div style={{ position: "absolute", maxHeight: "300px", overflow: "auto", width: '100%', backgroundColor: '#333333', borderRadius: '5px', zIndex: 100, marginTop: '8px' }}>
                {Object.entries(LLMs).map(([provider, models]) => (
                  <div key={provider}>
                    <div style={{ padding: '10px', fontWeight: 'bold', color: '#8C2BE4' }}>
                      {provider.toUpperCase()} MODELS
                    </div>
                    {models.map(model => (
                      <div
                        key={model.value}
                        onClick={() => handleTestCaseModelSelect(provider, model.value)}
                        style={{
                          padding: '10px 20px',
                          cursor: 'pointer',
                          color: 'white',
                          backgroundColor: model.value === testCaseExecuteModel ? '#8C2BE4' : 'transparent',
                        }}
                      >
                        {model.label}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </Form.Item>
        </Form>
      </Modal>
      <Modal visible={testcaseModelVisible}
      footer={
        <><Button onClick={()=>setTestcaseModelVisible(false)}>Close</Button>
        <Button onClick={runtestcase}>Run Test</Button></>
      }
      onCancel={()=>setTestcaseModelVisible(false)}
      ><Collapse style={{ marginTop: "20px" }}>
               
                  {displayTestCases?.map((testcase, index) => (
                   
                    <Panel key={testcase?.id} header={testcase?.name}>
                      <p><strong>Testcase ID :</strong> {testcase?.id}</p>
                      <p><strong>Testcase Input :</strong> {testcase?.input.toUpperCase()}</p>
                      <p><strong>TestCase Output :</strong> {testcase?.output.toUpperCase()}</p>
                      <p><strong>TestCase Agent Name :</strong> {testcase?.agent?.name}</p>
                    </Panel>
                  
                  ))}
          </Collapse></Modal>

          <Modal
      title="Test Cases Report"
      visible={testcaseReport}
      onCancel={()=>setTestcaseReport(false)}
      footer={null}
    >
      <List
        itemLayout="horizontal"
        dataSource={testcaseStatus}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={item.testcaseName}
              description={`Test Case ID: ${item.
                testcaseId
                }`}
            />
            <Tag color={item.status === "true" ? "green" : "red"}>
              {item.status === "true" ? "Success" : "Failed"}
            </Tag>
          </List.Item>
        )}
      />
    </Modal>
      

    </Layout>
  );
};

export default Chat;
